import { Button, Form, Input, message, Modal } from 'antd';
import { useState } from 'react';
import { updateCycle } from 'services/api/cycles';

const RenameCycleModal = ({ cycle, open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const onFinish = (values) => {
    setLoading(true);
    updateCycle({ cycleId: cycle._id, name: values.name })
      .then(() => {
        onClose();
      })
      .catch((err) => {
        message.error(err.message);
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Modal open={open} onCancel={onClose} title="Rename Cycle" footer={null}>
      {cycle && (
        <Form
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ name: cycle.name }}
        >
          <Form.Item label="Cycle Name" name="name">
            <Input value={cycle.name} />
          </Form.Item>
          <Form.Item>
            <Button
              loading={loading}
              type="primary"
              htmlType="submit"
              style={{ width: '100%' }}
            >
              Rename
            </Button>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default RenameCycleModal;
